import { createMuiTheme } from "@material-ui/core";

const theme = createMuiTheme({
  props: {
		MuiButtonBase: {
			// Name of the component ⚛️
			disableRipple: true, // ripple animation disabled
    },
  },
})

export default theme;
